import gruhapravesham1_background from "../images/gruhapravesham/gruhapravesham1_background.png";
import gruhapravesham1 from "../images/gruhapravesham/gruhapravesham1.png";
import '../invitations/Invitation.css'

const gruhapravesham1InvitationElements = [

  // 🌌 BACKGROUND
  {
    id: 13,
    type: "background",
    src: gruhapravesham1_background,
    x: 0,
    y: 0,
    width: 595,
    height: 842
  },

  // 🏡 GRUHA PRAVESHAM IMAGE
  {
    id: 14,
    type: "image",
    src: gruhapravesham1,
    x: 88,
    y: 480,
    width: 415,
    height: 300,
  },

  // ✨ TAGLINE
  {
    id: 3,
    type: "text",
    text: "Happiness • Blessings • New Beginnings",
    x: 170,
    y: 290,
    fontSize: 17,
    fontFamily: "Great Vibes",
    fill: "#d1a035"
  },

  // 🏡 MAIN TITLE
  {
    id: 4,
    type: "text",
    text: "🏡GRUHA PRAVESHAM🏡",
    x: 150,
    y: 260,
    fontSize: 24,
    fontFamily: "Playfair Display",
    fill: "#d1a035"
  },

  // ✨ DIVIDER
  {
    id: 5,
    type: "text",
    text: "──────── ✦ ────────",
    x: 200,
    y: 300,
    fontSize: 15,
    fontFamily: "Poppins",
    fill: "#d1a035"
  },

  // 🙏 DESCRIPTION
  {
    id: 6,
    type: "text",
    text: "With immense joy, we invite you and your family",
    x: 150,
    y: 320,
    fontSize: 11,
    fontFamily: "Poppins",
    fill: "#d1a035"
  },

  {
    id: 16,
    type: "text",
    text: "to grace our House Warming Ceremony with your blessings",
    x: 120,
    y: 340,
    fontSize: 11,
    fontFamily: "Poppins",
    fill: "#d1a035"
  },

  // 📅 DATE
  {
    id: 7,
    type: "text",
    text: "📅 Date: 12 March 2027",
    x: 130,
    y: 400,
    fontSize: 12,
    fontFamily: "Poppins",
    fill: "#d1a035"
  },

  // ⏰ TIME
  {
    id: 8,
    type: "text",
    text: "⏰ Time: 9:00 AM",
    x: 150,
    y: 420,
    fontSize: 13,
    fontFamily: "Poppins",
    fill: "#d1a035"
  },

  // 📍 VENUE
  {
    id: 9,
    type: "text",
    text: "📍 Venue:",
    x: 400,
    y: 380,
    fontSize: 15,
    fontFamily: "Playfair Display",
    fill: "#d1a035"
  },

  {
    id: 10,
    type: "text",
    text: "Sai Residency",
    x: 410,
    y: 400,
    fontSize: 11,
    fontFamily: "Poppins",
    fill: "#d1a035"
  },

  {
    id: 11,
    type: "text",
    text: "Vijayawada",
    x: 395,
    y: 420,
    fontSize: 15,
    fontFamily: "Poppins",
    fill: "#d1a035"
  },

  // 🌟 FOOTER
  {
    id: 12,
    type: "text",
    text: "Your Presence Will Make Our Home Complete",
    x: 130,
    y: 450,
    fontSize: 21,
    fontFamily: "Great Vibes",
    fill: "#d1a035"
  }

];

export default gruhapravesham1InvitationElements;